'use client'

import CountryLangSelector from '@/components/CountryLangSelector'
import { TrustBox } from '@sedomicilier/material-sd'
import { useTranslations } from 'next-intl'

const Footer = () => {
  const t = useTranslations()
  return (
    <footer className='h-[80px] p-4 flex justify-between items-center bg-neutral-150'>
      <CountryLangSelector />
      <div className='tablet:flex body-2 m-auto mobile:hidden'>
        <span>{t('common.trust')}</span>
        <TrustBox />
      </div>
    </footer>
  )
}

export default Footer
